/**
 * Whether two car names would be *read aloud* differently.
 *
 * The announcer keeps two clips per car: a human recording, and a synthesised fallback. A rename makes a
 * recording wrong rather than merely stale — playing "Grave Digger" for a car now called "Son-UVA Digger"
 * is worse than the computer voice that is at least correct — so the server discards the recording and
 * re-synthesises. This decides when that is about to happen, so the phone can ask first.
 *
 * **Case and whitespace deliberately do not count.** Correcting "megalodon" to "Megalodon" or removing a
 * double space is the most ordinary edit there is and changes nothing about what Polly says, so it must not
 * cost somebody a take. A confirmation prompt for an edit that costs nothing is how people learn to dismiss
 * prompts without reading them, which is what makes the one that matters ineffective.
 *
 * Mirrors `_spoken_differently` and `announcer.spoken_form` in the API. The server is where the rule is
 * enforced, because a rename from any other client has the same consequence; this copy exists only so the
 * warning appears before the request rather than after it. If the two ever disagree, the server wins and
 * the symptom is a missing or spurious prompt rather than lost data.
 */
export function spokenForm(name: string | null | undefined): string {
  return (name ?? "").split(/\s+/u).filter(Boolean).join(" ").slice(0, 60);
}

export function saidDifferently(before: string | null | undefined, after: string | null | undefined) {
  return spokenForm(before).toLocaleLowerCase() !== spokenForm(after).toLocaleLowerCase();
}
